import React, { useState } from 'react';
import {connect, useSelector} from 'react-redux';
import {push} from 'connected-react-router'
import {rjscSearchResultSelect} from '../../redux/selector/rjscSearchSelector'
import {
    Header, 
    Paragraph,
    Button,
    ErrorMark
} from '../../components/RegularComponents'
import TopNavigationBar from '../TopNavigationBar';
import { Pagination } from '../../components/Pagination/Pagination'
import { fetchOperatingBusinessData, fetchRjscFromNumberAndSetDetails, setRjscAdvanceSearchString } from '../../redux/slice/rjscSearchSlice';
import { APPLICATION_MODE_NEW, APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE, LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION, ROUTE_PATH } from '../../app/constants';
import { applicationTypeFromLicenceSubType } from '../../redux/slice/applicationsUtils'

const MLRJSCSearchResult = (props) => {
    const {rjscSearchResult, dispatch} = props
    const defaultRegistryNumber = rjscSearchResult.companyRjscRegistryNumber ? 
                                    rjscSearchResult.companyRjscRegistryNumber : 
                                    rjscSearchResult.searchResponseData ? rjscSearchResult.searchResponseData[0]?.businessEntity?.registryNumber : ""

    const [rjscSearchRegistryNumber, setRjscSearchRegistryNumber] = useState(defaultRegistryNumber)

    const [currentPage, setCurrentPage] = useState(1)
    const [showError, setShowError] = useState(false)
    const [fetchingRjscDetails, setFetchingRjscDetails] = useState(false)

    const itemsPerPage = 100

    const { licencingSubType } = useSelector((state) => ({
        licencingSubType : state.primaryAgencyApplication.application?.licencingSubType ?? LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION,
      }));
    
    const applicationType = applicationTypeFromLicenceSubType(licencingSubType);
    const isLender = (applicationType === APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE)

    /* There are two paths from here : 
     1. If the search is with the rjsc number : 
          - Assumption here is that the selected business is already 
            the operating business.
     2. If the search is with rjsc name :
          - The selected name is legal name. 
          - We need to search the operating business names for the selected entity.
          - There are three options from here : 
              - A. There are no operating businesses
                    - Keep the selected legal name as operating business 
              - B. There is exactly one operating business
                    - Keep the single operating business as the operating business
              - C. There are multiple operating businesses
                    - Show all options and let user select the operating business
    */  
    const onNextClick = () => {
        if(!rjscSearchRegistryNumber){
            setShowError(true);
            return
        }

        setFetchingRjscDetails(true)
        
        const searchResultItem = currentPageItems().find(item => item.registryNumber === rjscSearchRegistryNumber)

        // if the selected search is name search : 
        if(1 || (rjscSearchResult.searchType === "rjscSearchName" || 
            (searchResultItem && searchResultItem.isParentEntity))) {
            dispatch(setRjscAdvanceSearchString({searchText : rjscSearchRegistryNumber})) 
            dispatch(fetchOperatingBusinessData(rjscSearchRegistryNumber, "rjscSearchName"))
                .then(data => {
                    // TODO : check the size of this response.
                    dispatch(push(`${isLender ? ROUTE_PATH.ML_APP : ROUTE_PATH.MA_APP}${ROUTE_PATH.ML_RJSC_OPERATING_NAME_SEARCH_SELECT}`))
                })
        } else {
            dispatch(fetchRjscFromNumberAndSetDetails(rjscSearchRegistryNumber))
            .then((data) => {
                dispatch(push(`${isLender ? ROUTE_PATH.ML_APP : ROUTE_PATH.MA_APP}${ROUTE_PATH.ML_RJSC_DETAIL_REVIEW}`))
              }
            )
            .catch(err => {
                setShowError(true)
            })
        }
    }

    const currentPageItems = () => {
        if(!rjscSearchResult || !rjscSearchResult.searchResponseData)
            return []
        
        let startIndex = ((currentPage - 1) * itemsPerPage)
        return rjscSearchResult.searchResponseData.slice(startIndex, startIndex + itemsPerPage)
    }

    const totalPages = () => {
        if(!rjscSearchResult || !rjscSearchResult.searchResponseData)
            return 0

        return (parseInt(rjscSearchResult.searchResponseData.length / itemsPerPage) 
            + ((rjscSearchResult.searchResponseData.length % itemsPerPage > 0) ?  1 : 0 ))
    }

    return (
    <>
        <div className="container">
            <TopNavigationBar 
                {...props} 
                applicationType={applicationType} 
                applicationMode={APPLICATION_MODE_NEW} />
            <div className="row">
                <div className="col-lg-8">
                    <Header 
                        id="rjs-search-results-header" 
                        header="Select your legal business name" />
                    <Paragraph 
                        id="rjsc-search-results-text"
                        // text={['Select your legal business name from the list from Registry of Joint Stock Companies (RJSC)']}
                        text={[
                            "Your legal name and any operating/business names registered under Nova Scotia Registry of Joint Stock Companies (RJSC) will appear on this list.",
                            "Select the legal name from RJSC that you want to appear on your licence."
                        ]}
                    />
                </div>
            </div>

            {fetchingRjscDetails ? 
                (<div className="row">
                    <div className="col-12 centered">
                        <p className="statusText">
                            fetching data...
                        </p>
                    </div>
                </div>) : 
                (<div className={"row"}>
                    <div className={"col-8"}>
                        <fieldset className="ns-fieldset">
                            <div className={"ns-radios ns-radios--small"}>
                                {currentPageItems().map(d => {
                                    // const {registryNumber, entityId, businessName} = d.businessEntity
                                    const {registryNumber, entityId, businessName} = d
                                    
                                    return (
                                        <div key={entityId} className="ns-radios__item">
                                            <input 
                                                className="ns-radios__input"
                                                key={entityId + "-input"}
                                                type={"radio"} 
                                                value={registryNumber} 
                                                checked={(rjscSearchRegistryNumber === registryNumber)}
                                                onChange={(e) => {
                                                    setRjscSearchRegistryNumber(e.target.value);
                                                    setShowError(false);
                                                }}
                                                id={"rjsc-search-result-"+entityId + "-input"} 
                                                name={"rjsc-search-result-"+entityId + "-input"} 
                                            />
                                            <label 
                                                key={entityId + "-label"}
                                                id={"rjsc-search-result-"+entityId + "-label"}
                                                className="ns-radios__label"
                                                htmlFor={"rjsc-search-result-"+entityId + "-input"}>
                                                    <span className="ns-label-span">
                                                        {`${businessName} (# ${registryNumber})`}
                                                    </span>
                                            </label>
                                        </div>
                                    )
                                })}
                            </div>
                        </fieldset>
                    </div>
                </div>)
            }

            {totalPages() > 1 ? 
                <div className="row">
                    <div className="col-8">
                        <Pagination 
                            totalPages={totalPages()}
                            currentPage={currentPage}
                            onPageChange={(pageNum) => {
                                setCurrentPage(pageNum)
                            }}
                        />
                    </div>
                </div> : null
            }
            
            
            <div className="row bottomMarginNormal">
                <div className={"col-lg-4" + (showError ? " has-error" : "")}>
                    <Button 
                        showSpinner={fetchingRjscDetails}
                        id="rjsc-search-result-button"
                        text={"Next"}
                        buttonType={"regular_primary"}
                        style={{marginTop: "15px"}}
                        onClick={onNextClick}
                    />
                    {showError && ErrorMark()}
                </div>
            </div>
            {showError && 
            <div className="ns-error-message help-block">
                {!rjscSearchRegistryNumber ? "Please select a legal business name" : "Could not find RJSC details"}
            </div>}
        </div>
    </>
    )
}

export default connect(rjscSearchResultSelect) (MLRJSCSearchResult)
